import RoutesMap from '../../route_control/RouteControl.js'
import {
    AssignSubjectTeacherList,
    AddAssignSubjectTeacher,
    UpdateAssignSubjectTeacher,
    AssignCourseSubjectList,
    AddAssignCourseSubject,
    UpdateAssignCourseSubject
} from '../../pages/assign'

export const AssignImport = {
    RoutesMap,
    AssignSubjectTeacherList,
    AddAssignSubjectTeacher,
    UpdateAssignSubjectTeacher,
    AssignCourseSubjectList,
    AddAssignCourseSubject,
    UpdateAssignCourseSubject
}
